import { ContextMenu } from 'radix-ui';
import type { ToolMenuEntry, ToolMenuSection } from './types';

function EntryList({ entries }: { entries: ToolMenuEntry[] }) {
  return (
    <>
      {entries.map((entry, index) => {
        if (entry.kind === 'separator') {
          return <ContextMenu.Separator key={`sep-${index}`} className="menu-separator" />;
        }
        if (entry.kind === 'sub') {
          return (
            <ContextMenu.Sub key={`sub-${entry.label}-${index}`}>
              <ContextMenu.SubTrigger className="menu-item">
                <span>{entry.label}</span>
                <span className="menu-item__shortcut">▸</span>
              </ContextMenu.SubTrigger>
              <ContextMenu.Portal>
                <ContextMenu.SubContent className="menu-content" sideOffset={4}>
                  <EntryList entries={entry.children} />
                </ContextMenu.SubContent>
              </ContextMenu.Portal>
            </ContextMenu.Sub>
          );
        }
        return (
          <ContextMenu.Item
            key={`item-${entry.label}-${index}`}
            className="menu-item"
            disabled={entry.disabled}
            onSelect={entry.onSelect}
          >
            <span>
              {entry.checked ? '✓ ' : ''}
              {entry.label}
            </span>
            {entry.shortcut && <span className="menu-item__shortcut">{entry.shortcut}</span>}
          </ContextMenu.Item>
        );
      })}
    </>
  );
}

/** Renders tool-option sections inside an open canvas ContextMenu. */
export function ToolContextMenuItems({ sections }: { sections: ToolMenuSection[] }) {
  if (sections.length === 0) return null;
  return (
    <>
      {sections.map((section) => (
        <EntryList key={section.id} entries={section.entries} />
      ))}
      <ContextMenu.Separator className="menu-separator" />
    </>
  );
}
